<template>
<div>
<!-- <span class="Maintitle">
    <i class="fas fa-file-prescription"></i>
      <strong> MSSCS Administration Application</strong>
      <span class="float-right"><strong>User Name: {{UserName}}</strong></span>
  </span>
<h4><small class="text-muted"><i class="fas fa-clinic-medical"></i><b>  Manage Clinic:</b></small></h4> -->

<Subtitle  v-bind:ServiceID="this.AppServiceID">
<template v-slot:header>
<i class="fas fa-clinic-medical"></i><b>  Manage Clinic:</b>
</template> 
</Subtitle>  
<Card>
  <CardBody>
  <p>Manage Clinic is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
  </p> 
</CardBody>
</Card> 
<b-modal id="infoModal" size="lg" v-model="showInfoModal"  no-close-on-esc no-close-on-backdrop hide-header-close
      ok-variant cancel-variant hide-footer
       header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant> 
     <ClinicDetails v-if="showInfoModal==true" :UserData="UserData"></ClinicDetails>
     <template slot="modal-header"   slot-scope="{ close }"> 
        <div>
        <small class="PopUpTitle w-100 text-left"></small>
      </div> 
      <div><small class="PopUpTitle">Clinic Details</small></div>
      <div><small class="PopUpTitle w-100 text-right"></small></div>
    </template>  
  </b-modal> 
<b-modal id="editModal" v-model="showEditModal"  size="lg" no-close-on-esc no-close-on-backdrop hide-header-close
      ok-variant cancel-variant hide-footer
      header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant> 
     <ClinicAddEdit v-if="showEditModal==true" :UserData="UserData" :mode="mode" @clinicUpdated="closeModal"></ClinicAddEdit>
     <template slot="modal-header"   slot-scope="{ close }"> 
        <div>
        <small class="PopUpTitle   w-100 text-left">{{mode}} Clinic</small>
      </div> 
      <div v-show="mode=='Edit'"><small class="PopUpTitle w-100 text-right">Clinic Number: {{UserData.clinicno}}</small></div>
    </template> 
     <!-- <div slot="modal-footer" class="w-100"> 
     </div> -->
  </b-modal> 

    <v-client-table :columns="columns" :data="tableData" :options="options">
     <!-- <span slot-scope="props" slot="status" v-if="row.status.toUpperCase() == 'ACTIVE'" style="color:green"><i class="fas fa-check-circle"
       v-b-tooltip.hover.right="'Inactive'"></i></span>   -->

     <!-- <span slot-scope="props"  v-else-if="status() == 'INACTIVE'" style="color:red"><i class="fas fa-times-circle" 
     v-b-tooltip.hover.right="'Inactive'"></i></span>   -->

     <!-- <span  slot-scope="props" slot="status" v-if="status() == 'FUTURE'" style="color:red"><i class="fa fa-arrow-circle-right"  
        v-b-tooltip.hover.right="'Future Dated'"></i></span>      -->

    <!-- status(h, row) {
               if((moment(row.effectivedate)).toISOString() > moment().startOf('day').toISOString()){
                   return <span style="color:red" v-b-tooltip title="Future Dated"><i class="fa fa-arrow-circle-right"></i></span>  
                 }
               if((moment(row.expirydate)).toISOString() <= moment().startOf('day').toISOString()){
                   return <span style="color:red" v-b-tooltip title="Inactive"><i class="fas fa-times-circle"></i></span>  
                 }  
               else
                   return <span style="color:green" v-b-tooltip title="Active"><i class="fas fa-check-circle"></i></span>
               } -->
    
     <span class="pointer" v-on:click="EditClinicPopup(props.row)" slot="edit" slot-scope="props" ><i class="far fa-edit"></i></span>
     <span class="pointer" v-on:click="ClinicDetailsPopup(props.row)" slot="info" slot-scope="props" ><i class="far fa-question-circle"></i></span>
          


     <div   v-if="showEdit" slot="beforeFilter"  class="VueTables_Adduser">
        <label for="VueTables_Adduser" class="VueTables_user"> Add New Clinic: </label>
          <button type="button" v-on:click="AddClinicPopup" class="btn btn-primary form-control mr-2">ADD CLINIC</button>
     </div>
    </v-client-table>   
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import Vue from 'vue';
import moment from 'moment'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '@/Common/ModelPop.vue';
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import { scrypt } from 'crypto';
import ClinicDetails from '@/components/DPEBB/Administrator/ClinicDetails.vue';
import ClinicAddEdit from '@/components/DPEBB/Administrator/ClinicAddEdit.vue';
import Subtitle from '@/Common/Default/SubTitle.vue';  
export default {
    props:{
      AllowEdit:''
    },
    data: function(){
        return {
        AppServiceID:6,
        showEdit:true,
        showInfoModal:false,
        showEditModal:false,
        PopUpVar:PopUpVariant,
        UserData:'',
        mode:'',
        // columns: ['edit' , 'clinicno','name','clinicname','effectivedate','expirydate',
        // 'address1','address2','address3','provincecode','postalcode','businessphoneno',
        // 'businessfax','emailaddress','clinicmanager','midasSupplierno','midassuppliersite',
        // 'codepayment','modifyUser','lastModifieddatetime','creatuser','createddatetime'],
        columns: ['status','info','edit' , 'clinicno','name','clinicname','effectivedate','expirydate',
        'businessphoneno',  'clinicmanager','address1','address2','address3','postalcode','provincecode','midassupplierno','codepayment'],
        tableData: [],
        options: {
        texts:{
              count:"Showing {from} to {to} of {count} records|{count} records|One record",
              first:'First',
              last:'Last',
              filter:"Search Clinic Data:",
              filterPlaceholder:"Search in table",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          }, 
       
          responseAdapter({data}) {
           
              return {
                data: formatData,
                count: data.length
              };
             
            },
         
          perPage:10,
          perPageValues:[10,15,25],
          dateColumns:['effectivedate','expirydate'],
          toMomentFormat: 'YYYY-MM-DD',
         
          templates: {
            effectivedate(h, row){
              return moment(row.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            },
            expirydate(h, row) {
              return moment(row.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            },
            businessphoneno(h, row) {
              if (row.businessphoneno.substring(0,2)=='--')
              {
                return <span></span>;                
              }
              else
                return <div>{row.businessphoneno}</div>;
            },
            businessfax(h, row) {
              if (row.businessfax.substring(0,2)=='--')
              {
                return <span></span>;                
              }
              else
                return <div>{row.businessfax}</div>;
            },
            codepayment(h, row){
              switch(row.codepayment.toUpperCase()){
                case 'E':
                  return 'Electronic Remittance'
                case 'C':
                  return 'Cheque'
                default:
                  return '';
              }
            },
            clinicno(h, row){
               return  ('00000' + row.clinicno.toString()).substring(row.clinicno.toString().length);//(parseInt(row.clinicno.toString().length)); //('00000' + row.clinicno).substring((('00000' + row.clinicno).length - row.clinicno.toString().length),5);
            },
            status(h, row) {
              if(row.pending ==true)
              {
                  return <span class='bigred'>PENDING</span>
              }
              else if(row.pending ==false)
              {
                if((moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD')) > moment().startOf('day').format('YYYY/MM/DD')){
                    return  <span>FUTURE</span>
                      ///(<span style="color:red" v-b-tooltip title="Future Dated"> <span style="display:none">Future</span><i class="fa fa-arrow-circle-right"></i></span> ); 
                  }
                if((moment(row.expirydate,"YYYY-MM-DD").format('YYYY/MM/DD')) <= moment().startOf('day').format('YYYY/MM/DD')){
                    // return (<span style="color:red" v-b-tooltip title="Inactive"><span style="display:none">Inactive</span><i class="fas fa-times-circle"></i></span>  );
                    return  <span >INACTIVE</span>
                  }  
                else
                    return  <span>ACTIVE</span>
                    //return (<span style="color:green" v-b-tooltip title="Active"><span style="display:none">Active</span><i class="fas fa-check-circle"></i></span>);
                    //  if(row.status.toUpperCase() == 'ACTIVE'){   }
              }
            } 
               
          },
          headings: {
            status : 'Status',
            info:'View',
            edit: 'Edit',
            clinicno: 'Clinic #',
            name: 'Service Type',
            clinicname: 'Clinic Name',
            emailaddress: 'Email Address',
            effectivedate: 'Effective Date',
            expirydate: 'Expiry Date',
            address1: 'Address 1',
            address2: 'Address 2',
            address3: 'City',
            provincecode: 'Province',
            postalcode: 'Postal Code',
            businessphoneno: 'Phone No',
            businessfax: 'Fax No',
            emailaddress: 'Email',
            clinicmanager: 'Clinic Manager',
            midassupplierno: 'Midas Supplier No',
            midassuppliersite: 'Midas Supplier Site',
            codepayment: 'Code Payment',
            modifyuser: 'Last Modified By',
            lastmodifieddatetime: 'Last Modified Date',
            createuser: 'Created By',
            createddatetime: 'Created Date'
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: ['clinicno','name','clinicname','effectivedate','expirydate',
        'address1','address2','address3','provincecode','postalcode','businessphoneno',
        'businessfax','emailaddress','clinicmanager','midassupplierno','midassuppliersite',
        'codepayment','modifyuser','lastmodifieddatetime','createuser','createddatetime'],
         filterable: [ 'status','clinicno','name','clinicname','effectivedate','expirydate',
        'address1','address2','address3','provincecode','postalcode','businessphoneno',
        'businessfax','emailaddress','clinicmanager','midassupplierno','midassuppliersite',
        'codepayment','modifyuser','lastmodifieddatetime','createuser','createddatetime'],
  
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
    }
        }
        },
        components: {

          Modal:Modal,
          ClinicDetails,
          Card,
          CardBody,
          TileNote,
          ClinicAddEdit,
          Subtitle
    },
        created: function(){
              this.showEdit = this.AllowEdit;
              this.loadTable();
              //console.log(this.paginate)
        },
        mounted() {
     // hide admin column
     if (!this.showEdit) {
          this.columns.splice(this.columns.findIndex(column => column == 'edit'), 1);
     }},
     computed:{
 
    },
     methods:{
      closeModal() { 
        this.showEditModal = false;
        this.loadTable();
        //this.$refs.table.refresh();
      },
   GoBack(){
            this.$router.push('/DPEBB/MainHome')
        },
        loadTable(){
        var vm = this;
         axios.get('SaskHealthApi/Codes/ViewClinics?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
         .then(function (response) {
               vm.tableData=response.data;
              
            })
            .catch(function (er) {
                console.log(er)
            });
      },
      ClinicDetailsPopup(Rowdata){
        this.UserData = Rowdata;
        this.showInfoModal = true;
      },
      EditClinicPopup(Rowdata){
        this.mode='Edit';
        this.UserData = Rowdata;
        this.showEditModal=true;
      },
      AddClinicPopup(Rowdata){
        this.mode='Add';
        this.UserData = '';
        this.showEditModal=true;
      }
    }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 2em 1em;
}
.info {
  background-color: #00558C;
}  
.modalHeader {
  color: black;
  background-color: #00558C;
  text-align: center;
  font-weight: 600;
}
.options {
  text-align: left;
  padding: 1em 0em;
} 
</style>